export type CertificationState = {
  paginator: { pageNb: number; pageSize: number };
};

export const initialState: CertificationState = {
  paginator: { pageNb: 1, pageSize: 20 },
};
